import PedidosValidarService from "@/services/PedidosValidarService";

/**
 * Vuex module for the "Gestión de pedidos" board (card #417): drag-and-drop
 * state transitions. Shape follows the gold reference (store/modules/customers.js,
 * mirrored too by pedidosPreparar.js).
 */

const state = () => ({
  loading: false,
  error: null,
});

const getters = {};

const actions = {
  /**
   * Advances a pedido one estado forward via PUT pedidos/validar.
   * @param {{pedido: object, envio?: number}} payload
   */
  async avanzarPedido({ commit }, { pedido, envio }) {
    try {
      commit("SET_LOADING", true);
      const body = {
        id_pedido: pedido.id,
        id_estatus_pedido: pedido.id_estado,
      };
      const envioAEnviar = envio !== undefined ? envio : pedido.envio;
      if (envioAEnviar !== undefined) body.envio = envioAEnviar;

      const response = await PedidosValidarService.validar(body);
      commit("SET_ERROR", null);
      return response.data;
    } catch (error) {
      // Backend hardening (commit e1b14f02, ya en demo): un
      // id_estatus_pedido desactualizado/no soportado ahora devuelve HTTP
      // 409 con { error, code, mensaje }. Con axios, un 409 RECHAZA la
      // promesa (no resuelve con data.error=true) — error.message trae el
      // genérico de axios ("Request failed with status code 409"), no el
      // mensaje real. Se estructura el error re-lanzado con el mensaje y
      // code reales del backend para que el caller (GestionPedidos.vue)
      // pueda mostrarlo y decidir si fuerza un refetch según el code.
      const datosBackend = error.response?.data;
      const mensaje = datosBackend?.mensaje || error.message || "Error al actualizar el pedido";
      commit("SET_ERROR", mensaje);
      const errorEstructurado = new Error(mensaje);
      errorEstructurado.code = datosBackend?.code;
      errorEstructurado.data = datosBackend;
      throw errorEstructurado;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  /**
   * Runs the ordered list of backend steps returned by
   * transicionesGestionPedidos.evaluarDrop() for a single drag. Stops (and
   * throws) at the first failed/refused step so the caller can revert the
   * card and show why.
   */
  async ejecutarPasos({ dispatch }, { pedido, pasos, envio }) {
    for (const paso of pasos) {
      if (paso.tipo === "preparar") {
        const data = await dispatch(
          "pedidosPreparar/marcarPreparado",
          [pedido.id],
          { root: true },
        );
        if (!data || !data.movidos) {
          const error = new Error(
            "El pedido no pudo marcarse como Preparado.",
          );
          error.data = data;
          throw error;
        }
      } else {
        const data = await dispatch("avanzarPedido", {
          pedido,
          envio: paso.requiereEnvio ? envio : undefined,
        });
        if (data && data.error) {
          const error = new Error(
            data.mensaje || "No se pudo actualizar el pedido.",
          );
          error.data = data;
          throw error;
        }
      }
    }
  },
};

const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
